<template>
    <div>
        <vue-tags-input
            :placeholder="
                'ajouter'
            "
            v-model="word"
            :tags="data"
            :allow-edit-tags="true"
            @tags-changed="(newTags) => (data = newTags)" />
    </div>

</template>

<script>
    import uniqueId from "lodash.uniqueid";
	import VueTagsInput from "@johmun/vue-tags-input";

    import store from "../store";

	var clone = require("clone");

    export default {
        name: "array_tag_editor",
        components: {
            VueTagsInput
        },
        props: {
            start_data: {
				default: () => []
            },
            type: {
                default: "text"
            }
        },
        data: function () {
            return {				
                id: uniqueId(""),
                data: [],
                word: ""
            };
		},
        watch: 
        {
			data: {
				deep: true,
				handler() {
					this.$emit("update", this.data.map(function(value) {
                        return value.text;
                    }));
				},
			},
        },
		methods: {
            save()
            {
                return this.data;
            },
            load(data)
            {
                //console.log("load array_tag_editor")
                //console.log(data)
                this.data = data;
            },
            del(idx)
            {
                this.data.splice(idx, 1);
            },
            add()
            {
                this.data.push("");
            }
        },
		mounted: function () {
            var self = this;


            //console.log("start array_tag_editor")
            //console.log(this.start_data)

            if (this.start_data)
            {
                for (var i = 0; i < this.start_data.length; i++)
                {
                    //console.log({text: this.start_data[i], tiClasses: ["ti-valid"]})
                    this.data.push({text: this.start_data[i], tiClasses: ["ti-valid"]});
                }
            }
		},
    }

</script>